<template>
    <div>
        <span v-if="showLabel">{{field.label}}:</span>
        {{ getFieldValue }}
    </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      item: {
        type: Object
      },
      field: {
        type: Object,
        required: true
      },
      showLabel: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      getFieldValue () {
        if (this.item === null) {
          return ''
        }

        const value = this.item[this.field.handle]
        if (value === null) {
          return ''
        }
        if (isNaN(value)) {
          if (value.value !== null) {
            return moment(value.value).format('DD.MM.YYYY')
          }
        } else {
          return moment(value * 1000).format('DD.MM.YYYY')
        }

        return ''
      }
    },
    name: 'DateColumn'
  }
</script>

<style scoped>

</style>